import { cva, type VariantProps } from 'class-variance-authority';
import type { HTMLAttributes } from 'react';
import { cn } from '@/lib/utils';

/**
 * Badge theo tông semantic (Design System §19): success / warning / error / info / neutral.
 * `brand` chỉ cho nhãn thương hiệu, không dùng cho trạng thái.
 */
const badgeVariants = cva('inline-flex items-center rounded px-1.5 py-0.5 text-xs font-medium whitespace-nowrap', {
  variants: {
    variant: {
      default: 'bg-neutral-soft text-neutral-foreground',
      neutral: 'bg-neutral-soft text-neutral-foreground',
      success: 'bg-success-soft text-success-foreground',
      warning: 'bg-warning-soft text-warning-foreground',
      error: 'bg-error-soft text-error-foreground',
      info: 'bg-info-soft text-info-foreground',
      brand: 'bg-accent text-primary',
      outline: 'border border-border text-muted-foreground',
    },
  },
  defaultVariants: { variant: 'default' },
});

export function Badge({ className, variant, ...props }: HTMLAttributes<HTMLSpanElement> & VariantProps<typeof badgeVariants>) {
  return <span className={cn(badgeVariants({ variant }), className)} {...props} />;
}

export function Kbd({ children, className }: { children: React.ReactNode; className?: string }) {
  return <kbd className={cn('rounded border border-border bg-muted px-1 font-mono text-[10px] text-muted-foreground', className)}>{children}</kbd>;
}
